import { render, staticRenderFns } from "./MenuForm.vue?vue&type=template&id=55f4ee9c"
import script from "./MenuForm.vue?vue&type=script&lang=js"
export * from "./MenuForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55f4ee9c')) {
      api.createRecord('55f4ee9c', component.options)
    } else {
      api.reload('55f4ee9c', component.options)
    }
    module.hot.accept("./MenuForm.vue?vue&type=template&id=55f4ee9c", function () {
      api.rerender('55f4ee9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/form/MenuForm.vue"
export default component.exports